// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../Banner';

export const ArtifactTypeInfoBanner = () => {
  return (
    <Tailwind>
      <Banner variant="info" className="mt-16">
        <BannerFlexWrapper>
          <div className="mb-auto">
            <Icon name="info" />
          </div>
          <BannerTextWrapper style={{display: 'inline'}}>
            <BannerBoldText>Type cannot be edited later:</BannerBoldText> Please
            ensure that the artifact type doesn't have any typos. Once
            confirmed, you cannot edit/remove existing artifact types.
          </BannerTextWrapper>
        </BannerFlexWrapper>
      </Banner>
    </Tailwind>
  );
};
